import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SaleOrderPreparation } from '../sale-order-preparation';

export class SaleOrderPreparationBuilder {
  static fromJson(json): SaleOrderPreparation {
    return (json) ? new SaleOrderPreparation(
      json.hash,
      parseNumber(json.preparationDate),
      json.observations
    ) : null;
  }

  static fromJsonList(list): SaleOrderPreparation[] {
    return (isArray(list)) ? mapCollection(SaleOrderPreparationBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-preparation-builder.ts